import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["placeholder", "aria-label"]

import { computed, inject, PropType, ref, toRefs } from 'vue';
import { useSearchQueryStore } from "@/store/SearchQueryStore";
import { usePopupStore } from "@/store/AutocompletePopup/PopupStore";
import { useUrlStore } from "@/store/SerpPage/UrlStore";
import ClearQueryButton from "@/components/SerpPage/ResultsContainer/ClearQueryButton.vue";
import { SmartSearchConfigInterface, SmartSearchTranslationsInterface } from "@/core/types";
import DOMPurify from "dompurify";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
  autocomplete: Boolean,
  context: {
    type: String as PropType<'desktop' | 'mobile'>,
    default: 'desktop'
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

const urlStore = useUrlStore();
const queryStore = useSearchQueryStore();
const { searchQuery } = toRefs(queryStore);
const popupStore = usePopupStore();

const inputElement = ref<HTMLInputElement | null>(null);

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);
const SmartSearchTranslations = ref(inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!);

const { redirectionUrl } = SmartSearchConfig.value.appConfiguration;

const isMobileContext = computed(() => props.context === 'mobile');

const showButtonSetting = computed(() => props.autocomplete
    ? SmartSearchConfig.value.autocomplete.showButtonOnInput
    : SmartSearchConfig.value.serp.showButtonOnInput);

const showButtonOnInput = computed(() => showButtonSetting.value);

const inputInlineStyle = computed(() => isMobileContext.value ? {} : {
  position: 'relative',
  zIndex: 1000000
});

const inputClassList = computed(() => [
  'autocomplete-search__input',
  'q-form-control',
  'q-position-relative',
  'q-rounded-3',
  'q-shadow-sm',
  `autocomplete-search__input--${isMobileContext.value ? 'mobile' : 'desktop'}`,
  {
    'q-input-with-button': showButtonOnInput.value,
    'autocomplete-search__input-max-width': props.autocomplete && !isMobileContext.value
  }
]);

const containerClassList = computed(() => ({
  'autocomplete-popup__input-container--mobile': isMobileContext.value,
  'autocomplete-popup__input-container--desktop': !isMobileContext.value
}));

const customRedirects = window?._QONizer?.customSmartSearchConfig?.customRedirects || [];

const matchedRedirect = computed(() => {
  const queryLower = searchQuery.value.toLowerCase().trim();
  return customRedirects.find(redirect =>
      redirect.phrases.some(phrase => phrase.toLowerCase().trim() === queryLower)
  );
});

const handleKeyUpConditional = () => {
  if (props.autocomplete) {
    popupStore.handleKeyUp();
  }
};

const handleInputPointerDown = () => {
  if (!props.autocomplete) return;
  popupStore.showAutocomplete();
};

const handleRedirection = () => {
  const q = (queryStore.searchQuery || '').trim();

  if (!q) {
    popupStore.showAutocomplete();
    inputElement.value?.focus();
    return;
  }

  if (matchedRedirect.value) {
    window.location.href = matchedRedirect.value.url;
  } else {
    const sanitised = DOMPurify.sanitize(q);
    urlStore.goToSerpPage(
        redirectionUrl,
        sanitised
    );
  }
};

// dynamiczna pozycja Clear w zależności od obecności przycisku akcji
const clearRight = computed(() => (showButtonOnInput.value ? 56 : 12));

// eslint-disable-next-line no-undef
__expose({
  focusInput: () => inputElement.value?.focus()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["autocomplete-popup__input-container q-input-group q-mb-1 q-input-group q-flex-nowrap", containerClassList.value])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["autocomplete-search__input-wrap", {'has-action': showButtonOnInput.value}])
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "inputElement",
        ref: inputElement,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
        onKeyup: [
          handleKeyUpConditional,
          _withKeys(handleRedirection, ["enter"])
        ],
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(popupStore).showAutocomplete && _unref(popupStore).showAutocomplete(...args))),
        type: "text",
        class: _normalizeClass(inputClassList.value),
        style: _normalizeStyle(inputInlineStyle.value),
        id: "autocomplete-search__input",
        placeholder: SmartSearchTranslations.value.autocomplete.whatSearch,
        "aria-label": SmartSearchTranslations.value.autocomplete.typeTerm,
        "aria-describedby": "search-input",
        autocomplete: "off"
      }, null, 46, _hoisted_1), [
        [_vModelText, _unref(searchQuery)]
      ]),
      _createVNode(ClearQueryButton, {
        class: "clear-query-affix",
        style: _normalizeStyle({ right: clearRight.value + 'px' }),
        autocomplete: __props.autocomplete
      }, null, 8, ["style", "autocomplete"])
    ], 2),
    (showButtonOnInput.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "autocomplete-search__input-button q-btn q-btn-danger q-shadow-sm",
          type: "button",
          id: "autocomplete-search__input-button",
          onClick: handleRedirection
        }, _toDisplayString(SmartSearchTranslations.value.autocomplete.inputButton), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})